<template>
    <conversation-nav class="justify-between">
        <div class="flex gap-2 items-center">
            <vx-button size="sm" color="secondary" @click="emit('unloadContact')">
                <font-awesome-icon widthAuto :icon="faArrowLeft"></font-awesome-icon>
            </vx-button>
            <div class="flex gap-2 items-center">
                <font-awesome-icon widthAuto :icon="faUser" class="text-slate-300"></font-awesome-icon>
                <div class="inline-flex flex-wrap">
                    <span class="text-base text-slate-100 font-extrabold self-center mr-1">{{ contactTitle }}</span>
                    <span
                        v-if="formatPhoneNumber(contact.phone) !== contactTitle"
                        class="text-base text-slate-300 self-center"
                        >{{ formatPhoneNumber(contact.phone) }}</span
                    >
                </div>
            </div>
        </div>
        <vx-button
            v-if="!props.hideEdit"
            data-test="edit-button"
            size="sm"
            color="secondary"
            @click="emit('open:contactDetails')"
        >
            Edit
            <font-awesome-icon widthAuto :icon="faSquareArrowUpRight" inverse />
        </vx-button>
    </conversation-nav>
</template>
<script setup>
import { computed } from 'vue';
import { displayContactName, formatPhoneNumber } from '~/components/filters';
import { VxButton } from '@voxie/frontend-components';
import { faArrowLeft, faSquareArrowUpRight, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ConversationNav from '~/components/messages/browser-extension/components/ConversationNav.vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';

const props = defineProps({
    hideEdit: { type: Boolean, default: false },
});

const { contact } = useContactDetails();

const emit = defineEmits(['open:contactDetails', 'unloadContact']);

const contactTitle = computed(() => {
    return displayContactName(contact.value);
});
</script>
